import moment from "moment"

// Update locale globally
moment.updateLocale("en", {
  week: {
    dow: 1,
  },
})

export default moment
